module.exports = __webpack_public_path__ + "static/img/IMG_20240211_122105.5e4722c5.jpg";